import {formatDate} from "@/helpers/utils";

class SkuDuo {
  id = null;
  name = null;
  status = null;
  code = null;
  orgPrice = null;
  subjectId = null;
  level = null; // curriculumTypes
  gradeIds = [];
  lmsCodes = [];
  activationTypes = [];
  durationType = 'day';
  endDate = null;
  duration = null;
  transactionStatus = null;
  cardDisplayName = null;
  // type = 'duo';

  constructor(data) {
      this.id = data.id ?? null;
      this.code = data.code ?? null;
      this.name = data.name ?? null;
      this.status = data.status ?? null;
      this.orgPrice = data.orgPrice ?? null;
      this.subjectId = data.subjectId ?? null;
      this.level = data.level ?? null;
      this.gradeIds = data.gradeIds ?? [];
      this.lmsCodes = data.lmsCodes ?? [];
      this.activationTypes = data.activationTypes ?? [];
      this.durationType = data.durationType ?? 'month';
      this.endDate = data.endDate ? formatDate(data.endDate) : null;
      this.duration = data.duration ?? null;
      this.transactionStatus = data.transactionStatus ?? null;
      this.cardDisplayName = data.cardDisplayName ?? null;
      // this.type =  'duo';
  }
}

export default SkuDuo;